import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { IKeepInTouchScore } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'keepInTouch/scores';

export function useKeepInTouchAllScores({
	pageSize = 25,
	ownerOnly = false,
	minScore,
	enabled = true,
	meta = { toastErrorMessage: 'Failed to load scores' },
}: {
	pageSize?: number;
	ownerOnly?: boolean;
	minScore?: number;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
} = {}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<IKeepInTouchScore>>({
		enabled,
		queryFn: async ({ pageParam }) => {
			const params = new URLSearchParams({ pageSize: String(pageSize) });
			if (pageParam) params.set('pageToken', pageParam as string);
			if (ownerOnly) params.set('ownerOnly', 'true');
			if (minScore != null) params.set('minScore', String(minScore));
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<IKeepInTouchScore>>(
				`keepInTouch/scores?${params}`,
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, pageSize, ownerOnly, minScore],
		getNextPageParam: lastPage => lastPage.pageToken || undefined,
		initialPageParam: '',
		meta,
	});
}

export const invalidateKeepInTouchAllScores = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
